import { FC, useState, useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import Layout from 'layouts/Layout';
import PageTitle from 'components/PageTitle';
import Panel from 'components/Panel';
import PermissionGroupForm from '../components/PermissionGroupForm'
import Forbidden from 'pages/forbidden';
import { useHistory } from 'react-router';
import {
  updatePermissionGroup, Response, 
  RequestData, RequestTemplate, Errors, ErrorsTemplate, showPermissionGroup, PermissionGroup,
} from 'libs/apiClient/admin/permissionGroups'
import { indexPermissionGroupsPath } from 'routes/permissionGroups/path';

type urlProps = {} & RouteComponentProps<{id: string}>;

const Edit: FC<urlProps> = (props) => {
  const history = useHistory();
  const [requestData, setRequestData] = useState<RequestData>({...RequestTemplate});
  const [errors, setErrors] = useState<Errors>({...ErrorsTemplate});
  const [isForbidden, setIsForbidden] = useState<Boolean>(false);
  const id = props.match.params.id;

  const forbiddenCallback = () => { setIsForbidden(true); }

  useEffect(() => {
    const callback = (permissionGroup: PermissionGroup) => {
      setRequestData({
        name: permissionGroup.name,
        description: permissionGroup.description,
        authorizations: permissionGroup.authorizations?.map( a => {
          return { controller: a.controller, action: a.action }
        }),
      });
    };
    showPermissionGroup(id, callback, forbiddenCallback);
  }, [])

  const onSubmit = async() => {
    const callback = (res: Response) => {
      history.push(indexPermissionGroupsPath);
    }

    const errCallback = (err: Errors) => {
      setErrors(err);
    }

    await updatePermissionGroup(id, requestData, callback, errCallback, forbiddenCallback);
  }

  const Page = () => {
    return(
      <Layout>
        <PageTitle title="権限グループ編集" />
        <Panel>
          <PermissionGroupForm 
            formData={ requestData }
            setFormData={ setRequestData }
            errors={ errors }
            onSubmit={ onSubmit }
          />
        </Panel>
      </Layout>
    )
  }

  if (isForbidden) {
    return <Forbidden />;
  } else {
    return Page();
  }


}

export default Edit;